var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-popover',{attrs:{"placement":_vm.placement,"offset":"10"}},[_c('font-awesome-icon',{staticClass:"text-gray-600 hover:cursor-pointer hover:text-pastel-blue",attrs:{"icon":_vm.icon}}),_c('template',{slot:"popover"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }